export default "__VITE_ASSET__6QOmgf3c__"